import { render, staticRenderFns } from "./RandomABTest.vue?vue&type=template&id=21de1608&lang=pug&"
import script from "./RandomABTest.vue?vue&type=script&lang=ts&"
export * from "./RandomABTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports